import React from 'react';
import styles from '../layout/AdminLayout.module.css';

const AdminWriteComponent: React.FC = () => {
  return (
    <div className={styles.pageContainer}>
      <div>
        <h1 className={styles.pageTitle}>관리자 글쓰기</h1>
      </div>
      
      <div className={styles.pageContent}>
        <p>관리자 글쓰기 기능을 구현해주세요.</p>
      </div>
    </div>
  );
};

export default AdminWriteComponent;
